
const LandscapingProcess = () => {
  const steps = [
    {
      number: '1',
      title: 'Consultation',
      description: 'We discuss your garden vision, assess your space, and understand your needs',
      icon: 'ri-discuss-line',
    },
    {
      number: '2',
      title: 'Design &amp; Quote',
      description: 'Receive a detailed plan and transparent quote for your landscaping project',
      icon: 'ri-draft-line',
    },
    {
      number: '3',
      title: 'Implementation',
      description: 'Our skilled team brings your garden to life with quality workmanship',
      icon: 'ri-hammer-line',
    },
    {
      number: '4',
      title: 'Maintenance',
      description: 'Optional ongoing maintenance to keep your garden looking beautiful',
      icon: 'ri-plant-line',
    },
  ];

  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Our Landscaping Process
      </h2>
      <p className="text-gray-600 text-lg mb-12 leading-relaxed">
        From initial consultation to ongoing maintenance, we make creating your dream garden simple and stress-free.
      </p>

      <div className="bg-greenbg rounded-2xl p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 relative z-10">
                  <i className={`${step.icon} text-white text-3xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <div className="bg-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-3 font-bold text-primary border-2 border-primary">
                  {step.number}
                </div>
                <h3 className="font-bold text-lg text-charcoal mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandscapingProcess;
